'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('ipfs-repo'),
    repoVersion = _require.repoVersion;

var _require2 = require('../../utils'),
    withTimeoutOption = _require2.withTimeoutOption;

module.exports = function (_ref) {
  var repo = _ref.repo;

  /**
   * If the repo has been initialized, report the current version.
   * Otherwise report the version that would be initialized.
   *
   * @returns {number}
   */
  return withTimeoutOption( /*#__PURE__*/function () {
    var _version = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
      var match;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return repo._checkInitialized(options);

            case 3:
              _context.next = 11;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              // TODO: (dryajov) This is really hacky, there must be a better way
              match = [/Key not found in database \[\/version\]/, /ENOENT/, /repo is not initialized yet/].some(function (m) {
                return m.test(_context.t0.message);
              });

              if (!match) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", repoVersion);

            case 10:
              throw _context.t0;

            case 11:
              return _context.abrupt("return", repo.version.get(options));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    function version(_x) {
      return _version.apply(this, arguments);
    }

    return version;
  }());
};